import ScrollReveal from '../ScrollReveal/ScrollReveal';
import ImageCard from '../ImageCard/ImageCard';
import './ImageGrid.css';

function ImageGrid({ images, ariaLabel = 'Marathon gallery' }) {
  return (
    <section className="image-grid" aria-label={ariaLabel}>
      {images.map((item, index) => (
        <ScrollReveal key={item.id} index={index}>
          <ImageCard
            src={item.src}
            alt={item.alt}
            contentId={item.id}
            downloadName={`inmotion-${item.id}`}
          />
        </ScrollReveal>
      ))}
    </section>
  );
}

export default ImageGrid;
